@for (filter of filters(); track filter.key) {
  @let noneSelected = selected(filter.key).length === 0;
  <div
    class="flex flex-wrap items-center gap-sm"
    role="group"
    [attr.aria-label]="filter.label"
    [attr.data-chip-filter]="filter.key">
    <span class="text-xs text-neutral-500 me-x-sm">{{ filter.label }}</span>

    <button
      type="button"
      data-chip-all
      class="flex shrink-0 items-center gap-sm rounded-full border px-md py-[0.325rem] text-xs font-medium whitespace-nowrap transition-colors cursor-pointer focus-visible:ring-2 focus-visible:ring-updated-primary-300"
      [class]="
        noneSelected
          ? 'bg-neutral-100 border-neutral-400 text-neutral-900'
          : 'bg-white border-neutral-200 text-neutral-900 hover:bg-neutral-50'
      "
      [attr.aria-pressed]="noneSelected"
      (click)="selectAll(filter)">
      @if (noneSelected) {
        <span aria-hidden="true">✓</span>
      }
      {{ 'chips_filter_all_label' | transloco }}
      @if (filter.allCount != null) {
        <span class="font-normal text-neutral-500">{{ filter.allCount }}</span>
      }
    </button>

    @for (option of filter.options; track option.value) {
      @let isActive = isSelected(filter.key, option.value);
      <button
        type="button"
        data-chip-option
        class="flex shrink-0 items-center gap-sm rounded-full border px-md py-[0.325rem] text-xs font-medium whitespace-nowrap transition-colors cursor-pointer focus-visible:ring-2 focus-visible:ring-updated-primary-300"
        [class]="
          isActive
            ? 'bg-neutral-100 border-neutral-400 text-neutral-900'
            : 'bg-white border-neutral-200 text-neutral-900 hover:bg-neutral-50'
        "
        [attr.aria-pressed]="isActive"
        (click)="toggle(filter, option.value)">
        @if (isActive) {
          <span aria-hidden="true">✓</span>
        }
        @if (option.color) {
          <span
            class="size-1.5 shrink-0 rounded-full"
            [style.background-color]="option.color"></span>
        }
        {{ option.label }}
        @if (option.count != null) {
          <span class="font-normal text-neutral-500">{{ option.count }}</span>
        }
      </button>
    }
  </div>
}
